module.exports = __webpack_public_path__ + "img/category_24.ed74969d.png";